import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormArray, Validators } from '@angular/forms';
import { Subsection } from 'src/app/models/obs/subsection';
import { SubsectionService } from 'src/app/services/obs/subsection.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';

@Component({
  selector: 'app-admsubsection-block-form',
  templateUrl: './admsubsection-block-form.component.html',
  styleUrl: './admsubsection-block-form.component.scss'
})
export class AdmsubsectionBlockFormComponent implements OnInit {


  sub: Subsection = null;
  idsectionSelected: string = null;
  linkString: string = '<a href="url_destino" target="_blank">texto_a_enlazar</a>';
  isSectionBlocked: boolean = false;

  constructor(
    private t3Service: Tier3Service,
    private router: Router,
    private subS: SubsectionService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private tokenStorage: TokenStorageService,
    private userLogService: UserLogService
  ) { }

  ngOnInit() {
    this.getLastOrderSubsection();
  }

  orderLastSubsection: number = 1;
  getLastOrderSubsection() {
    this.idsectionSelected = this.activedRoute.snapshot.params['idsection'];
    this.getIsBlockedSection(+this.idsectionSelected);
    this.subS.getOrderLast4secAdm(this.idsectionSelected).subscribe({
      next: res => {
        if (res['status'] == 'OK') {
          this.orderLastSubsection = res['data'].order;
        }
        if (res['status'] == 'ERROR') {
          this.orderLastSubsection = 0;
        }
      },
      error: err => { }
    })
  }

  /* Incio codigo FormArray */

  fatherForm = this.fb.group({
    textbox: ['', Validators.required],
    dataset: this.fb.array([])
  })

  get dataset() {
    return this.fatherForm.get('dataset') as FormArray;
  }

  get textbox() {
    return this.fatherForm.get('textbox');
  }

  removerCampos() {
    this.dataset.clear();
  }

  tempInfo: string[];
  modelChangefn(event) {
    this.removerCampos();
    this.tempInfo = this.textbox.value.split('.\n')
    this.loadInfo(this.tempInfo);
  }

  loadInfo(subsection: Array<any>) {

    let formArray = this.dataset;
    let contOrder = 0;
    for (let i = 0; i < subsection.length; i++) {
      if (subsection[i] !== '') {

        formArray.push(
          this.fb.group({
            id: null,
            idsection: this.activedRoute.snapshot.params['idsection'],
            ideditor: null,
            order: contOrder + this.orderLastSubsection + 1,
            title: null,
            content: [subsection[i]] + '.',
            status: true,
          })
        )
        contOrder = contOrder + 1;
      }
    }
    /* console.log("Esto esta en array : ", (formArray.value)); */
  }


  /* Fin  codigo FormArray */
  dataLog = {};
  submit() {
    if (confirm('Se crearan ' + this.dataset.value.length + ' parrafos. ¿Esta deacuerdo?')) {
      for (let i = 0; i < this.dataset.value.length; i++) {
        this.sub = this.dataset.value[i]

        this.subS.create(this.sub).subscribe({
          next: res => {
            /* Inicio - crear log de actividad de usuario */
            if (res) {
              this.dataLog['iduser'] = this.tokenStorage.getUser().id;//el que esta realizando accion de crear
              this.dataLog['nameUser'] = this.tokenStorage.getUser().nombre;//Definimos el id del contenido que se esta creando 
              this.dataLog['idContent'] = res['data'].id;//Definimos el id del contenido que se esta creando 
              this.dataLog['nameComponent'] = 'Subsección';//determinamos si es figura, bilbiografia, seccion o subcion 
              this.dataLog['idtier3'] = this.idsectionSelected;//determinamos a que campo pertence el contenido creado
              this.dataLog['action'] = 'creación';//definimos que accion esta realizando

              this.userLogService.createUserLog(this.dataLog).subscribe({
                next: res => { },
                error: err => console.error(err)
              })
            }
            /* Fin - crear log de actividad de usuario */
            if (i + 1 == this.dataset.value.length) {
              this.router.navigate(['/adm/subseccion/list/', this.idsectionSelected]);
            }
          },
          error: err => { console.error(err) }
        })
      }
    }
  }

  cancel() {
    this.router.navigate(['/adm/subseccion/list/', this.idsectionSelected]);
  }

  getIsBlockedSection(id: number) {
    this.t3Service.idSectionblocked(id).subscribe({
      next: res => {
        this.isSectionBlocked = res['isBlocked'];
      },
      error: err => { console.log(err); }
    })
  }
}